<template>
  <div class="payResult">
    <van-sticky>
      <div
        class="payResultNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">支付结果</span>
      </div>
    </van-sticky>
    <div class="content" v-if="!loading">
      <div class="card succeed" v-if="result">
        <div>
          <img src="./../../../assets/decoration/complete.png" alt="" />
          <h2>支付成功</h2>
          <p>代理人申请费用已支付，申请审核中，请耐心等待</p>
        </div>
        <!-- <p>
          <span>支付方式</span>
          <span v-if="data.pay_type == 1">银联支付</span>
          <span v-if="data.pay_type == 2">支付宝支付</span>
          <span v-if="data.pay_type == 3">微信支付</span>
          <span v-if="data.pay_type == 4">余额</span>
          <span v-if="data.pay_type == 5">支付宝H5支付</span>
          <span v-if="data.pay_type == 6">微信H5支付</span>
        </p> -->
        <p>
          <span>支付金额</span>
          <span>{{ data.main_order ? data.main_order.total_amount : "" }}</span>
        </p>
      </div>
      <div class="card fail" v-else>
        <div>
          <img src="./../../../assets/decoration/erro.png" alt="" />
          <h2>支付失败</h2>
          <!-- <p>失败原因</p> -->
        </div>
      </div>
      <div class="succeedBtn" v-if="result">
        <span @click="goHome()">前往首页</span>
        <span @click="seeOrder()">查看订单</span>
      </div>
      <div class="failBtn" v-else>
        <span @click="againPay()">重新支付</span>
      </div>
    </div>
    <div class="loading" v-if="loading || delay">
      <img src="./../../../assets/decoration/laoding.gif" />
      <p>加载中...</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
      loading: true,
      result: true,
      ordersn: null,
      data: {},
      delay: false,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.result = JSON.parse(this.$route.query.result);
    if (this.$route.query.ordersn) {
      this.ordersn = this.$route.query.ordersn;
    }
    this.getData();
  },
  mounted() {
    window.setPay = this.setPay;
    window.decorationPayResult = this.decorationPayResult;
    window.decorateCancelPay = this.decorateCancelPay;
  },
  methods: {
    goBack() {
      this.delay = true;
      setTimeout(() => {
        this.delay = false;
        this.$router.push({
          path: "/decoration/deputy/details",
        });
      }, 3000);
    },
    goHome() {
      this.goBack();
    },
    getData() {
      this.$api
        .post("order/member/order/detail", {
          ordersn: this.ordersn,
          order: {
            type: "decoration",
          },
        })
        .then((res) => {
          this.loading = false;
          this.data = res;
        });
    },
    seeOrder() {
      // this.params("", "1", "decorateBackOn");
      this.delay = true;
      setTimeout(() => {
        this.delay = false;
        this.$router.push({
          path: "/decoration/deputy/payFeesDetails",
          query: {
            ordersn: this.ordersn,
          },
        });
      }, 3000);
    },
    againPay() {
      let param = {
        actual_amount: this.data.main_order.actual_amount,
        order_amount: this.data.main_order.order_amount,
        ordersn: this.ordersn,
        order_type: "decoration_city_agent",
      };
      this.params(
        JSON.stringify(param),
        JSON.stringify(param),
        "decorationPay"
      );
    },
    // ios支付结果回调
    decorationPayResult() {
      this.setPay("success");
    },
    // 安卓支付结果回调
    setPay(res) {
      let result = false;
      if (res == "success") {
        result = true;
      } else {
        let data = JSON.parse(res);
        // console.log(data);
        if (data.code == 0) {
          result = true;
        } else if (data.code == -1) {
          result = false;
          this.decorateCancelPay();
        }
      }
      // this.params("", "1", "decorateBackOff");
      if (result) {
        this.$router.push({
          path: "/decoration/deputy/payResult",
          query: {
            ordersn: this.ordersn,
            result: result,
          },
        });
      }
    },
    decorateCancelPay() {
      this.$router.push({
        path: "/decoration/deputy/details",
      });
    },
  },
};
</script>
<style lang="less">
.payResult {
  height: 100%;
  background: #f2f2f2;
  .payResultNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    margin: 0 16px;
    .card {
      margin-top: 12px;
      background: #ffffff;
      border-radius: 12px;
      padding: 0 24px;
      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 72px;
          height: 72px;
          margin-top: 48px;
        }
        h2 {
          font-size: 20px;
          color: #333333;
          line-height: 28px;
          margin: 32px 0 0;
        }
        p {
          font-size: 14px;
          color: #999999;
          line-height: 20px;
          margin: 16px 27px 0;
          text-align: center;
        }
      }
    }
    .succeed {
      padding-bottom: 32px;
      div {
        padding-bottom: 39px;
        border-bottom: 1px solid #f0f1ff;
        margin-bottom: 12px;
      }
      > p {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        font-size: 15px;
        color: #333333;
        line-height: 21px;
        span:first-child {
          color: #999999;
        }
      }
    }
    .fail {
      div {
        padding-bottom: 80px;
      }
    }
    .succeedBtn {
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
      span {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 15px;
        border-radius: 25px;
        width: 47%;
      }
      span:first-child {
        border: 1px solid #bdbfce;
        color: #666666;
      }
      span:last-child {
        border: 1px solid #5853e9;
        color: #5853e9;
      }
    }
    .failBtn {
      margin-top: 24px;
      display: flex;
      span {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 15px;
        border-radius: 25px;
        background-color: #5853e9;
        color: #ffffff;
        flex: 1;
      }
    }
  }
  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
    p {
      color: #e7e9fd;
      margin-top: -30px;
      font-size: 13px;
    }
  }
}
</style>